/**
 * Christmas Animations for Shopify
 * - Runs for 5 seconds on page load
 * - Won't run again for 60 minutes for the same user
 * - Multiple Christmas elements: snow, bells, santa hats, trees, stars, gifts
 */

(function() {
  'use strict';
  
  // Check if animation already played in last 60 minutes
  /* var lastPlayed = localStorage.getItem('xmas-animation-time');
  var now = new Date().getTime();
  var sixtyMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
  
  if (lastPlayed && (now - parseInt(lastPlayed)) < sixtyMinutes) {
    return; // Exit if already played within last 60 minutes
  }
  
  // Save current time
  localStorage.setItem('xmas-animation-time', now.toString()); */
  
  // Configuration
  var CONFIG = {
    duration: 5000,        // Animation runs for 10 seconds
    fadeOutTime: 2000,     // Fade out over 2 second
    elements: {
      snowflakes: 40,      // ❄️
      bells: 6,            // 🔔
      santaHats: 5,        // 🎅
      trees: 4,            // 🎄
      stars: 8,            // ⭐
      gifts: 5,            // 🎁
      candyCanes: 4,       // 🍬
      ornaments: 6         // 🎀
    }
  };
  
  // Create container
  var container = document.createElement('div');
  container.id = 'xmas-animation';
  container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;overflow:hidden';
  
  // Element configurations
  var elementConfigs = {
    snowflakes: { emoji: '❄', size: [10, 25], speed: [3, 6], color: '#fff', glow: 'rgba(255,255,255,0.8)' },
    bells: { emoji: '🔔', size: [20, 35], speed: [4, 6], swing: true, glow: 'rgba(255,215,0,0.6)' },
    santaHats: { emoji: '🎅', size: [25, 40], speed: [3, 5], rotate: true },
    trees: { emoji: '🎄', size: [30, 50], speed: [2, 4], rotate: true },
    stars: { emoji: '⭐', size: [15, 30], speed: [3, 6], glow: 'rgba(255,223,0,0.8)' },
    gifts: { emoji: '🎁', size: [20, 35], speed: [3, 5], rotate: true },
    candyCanes: { emoji: '🍬', size: [20, 35], speed: [3, 5], rotate: true },
    ornaments: { emoji: '🎀', size: [18, 30], speed: [3, 5], rotate: true }
  };
  
  // Create element
  function createElement(type, config) {
    var elem = document.createElement('div');
    elem.innerHTML = config.emoji;
    
    var size = Math.random() * (config.size[1] - config.size[0]) + config.size[0];
    var x = Math.random() * window.innerWidth;
    var duration = Math.random() * (config.speed[1] - config.speed[0]) + config.speed[0];
    var delay = Math.random() * 2;
    var opacity = Math.random() * 0.4 + 0.6;
    
    var style = 'position:absolute;top:-60px;left:' + x + 'px;font-size:' + size + 'px;opacity:' + opacity + ';';
    
    if (config.glow) {
      style += 'filter:drop-shadow(0 0 8px ' + config.glow + ');';
    }
    if (config.color) {
      style += 'color:' + config.color + ';text-shadow:0 0 5px ' + config.glow + ';';
    }
    
    elem.style.cssText = style;
    
    // Create animation
    var name = 'anim-' + type + '-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    var animStyle = document.createElement('style');
    var h = window.innerHeight;
    
    if (config.swing) {
      // Swinging animation for bells
      var swing = Math.random() * 40 + 20;
      var rotate = Math.random() * 30 - 15;
      animStyle.textContent = '@keyframes ' + name + '{' +
        '0%{transform:translateY(0) translateX(0) rotate(0deg)}' +
        '25%{transform:translateY(' + (h*0.25) + 'px) translateX(' + swing + 'px) rotate(' + rotate + 'deg)}' +
        '50%{transform:translateY(' + (h*0.5) + 'px) translateX(0) rotate(' + (-rotate) + 'deg)}' +
        '75%{transform:translateY(' + (h*0.75) + 'px) translateX(' + (-swing) + 'px) rotate(' + rotate + 'deg)}' +
        '100%{transform:translateY(' + (h+60) + 'px) translateX(0) rotate(0deg)}' +
      '}';
    } else if (config.rotate) {
      // Rotating animation
      var drift = Math.random() * 60 - 30;
      animStyle.textContent = '@keyframes ' + name + '{' +
        '0%{transform:translateY(0) translateX(0) rotate(0deg)}' +
        '100%{transform:translateY(' + (h+60) + 'px) translateX(' + drift + 'px) rotate(360deg)}' +
      '}';
    } else {
      // Simple falling animation (snowflakes, stars)
      var drift = Math.random() * 50 - 25;
      animStyle.textContent = '@keyframes ' + name + '{' +
        '0%{transform:translateY(0) translateX(0) rotate(0deg)}' +
        '100%{transform:translateY(' + (h+60) + 'px) translateX(' + drift + 'px) rotate(360deg)}' +
      '}';
    }
    
    document.head.appendChild(animStyle);
    elem.style.animation = name + ' ' + duration + 's ease-in ' + delay + 's';
    
    return elem;
  }
  
  // Initialize
  function init() {
    document.body.appendChild(container);
    
    // Create all elements
    for (var type in CONFIG.elements) {
      var count = CONFIG.elements[type];
      var config = elementConfigs[type];
      
      for (var i = 0; i < count; i++) {
        container.appendChild(createElement(type, config));
      }
    }
    
    // Remove after duration with fade out
    setTimeout(function() {
      container.style.transition = 'opacity ' + (CONFIG.fadeOutTime / 1000) + 's ease-out';
      container.style.opacity = '0';
      
      setTimeout(function() {
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      }, CONFIG.fadeOutTime);
    }, CONFIG.duration);
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
